<template>
  <div class="carouse-inv-mobile">
    <el-carousel
      :height="controlHeight"
      :autoplay="true"
      :interval="5000"
      arrow="always"
    >
      <el-carousel-item class="list1">
        <div class="banner-1 bg-video">
          <banner-bg></banner-bg>
          <div class="layour flex-r-cc">
            <div class="inner">
              <div class="box1">
                <img
                  src="//cdnw2.acmcoder.com/release/exam/2.0.1/images/wlogo.png"
                />
              </div>
              <div class="text">
                <div class="text1">视频面试流畅</div>
                <div class="text2">稳定好用的在线面试系统</div>
              </div>
              <div class="bottom-btns flex">
                <a class="btn1 ismobile" @click="goTest">现在体验</a
                ><a class="btn2" @click="chatShow">咨询顾问</a>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="banner-2">
          <div class="layout">
            <div class="inner">
              <div class="text">
                <div class="text1">
                  滴滴、头条/抖音、<br />
                  小红书、携程都在使用的在线面试系统
                </div>
                <div class="text2">
                  支持视频 · 音频 · 共享桌面<br />
                  编程 · 移动端多种模式
                </div>
              </div>
              <div class="bottom-btns flex" style="margin-top: 3px">
                <a class="btn1" @click="goTest">现在体验</a
                ><a class="btn2" @click="chatShow">咨询顾问</a>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import bannerBg from './banner-bg.vue'
export default {
  components: {
    bannerBg,
  },
  data() {
    return {
      isMobile: false,
      controlHeight: '560px',
    }
  },
  created() {
    this.isMobile = this.$store.state.app.device
  },
  methods: {
    goTest() {
      //在线面试的申请体验
      // this.$bus.emit('interviewTest')
      this.$alert('<p style="font-size: 16px; text-align: center; padding: 30px 0px;">请咨询顾问进行体验</p>', '提示', {
        confirmButtonText: '我知道了',
        dangerouslyUseHTMLString: true,
        callback: action => {
          this.$bus.emit('chatShow')
        }
      });
    },
    chatShow() {
      this.$bus.emit('chatShow')
    },
    resetHeight() {
      if (this.isMobile) {
        this.controlHeight = window.innerHeight - 250 + 'px'
      } else {
        this.controlHeight = window.innerHeight - 60 - 150 + 'px'
      }
    },
    bindResize() {
      window.onresize = this.resetHeight
    },
  },
  mounted() {
    this.resetHeight()
    this.bindResize()
  },
}
</script>

<style lang="scss" scoped>
.carouse-inv-mobile {
  padding: 0px 0px 0px;
  img {
    margin: auto;
    width: auto;
    max-width: 100%;
  }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 245px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.bg-video {
  width: 100%;
  height: inherit;
  left: 0px;
  top: 0px;
  z-index: -1;
  vertical-align: bottom;
  display: block;
  position: absolute;
}

.bottom-btns {
  padding: 45px 0px 0px;
  color: #fff;
  .btn1 {
    margin-left: 130px;
    font-size: 18px;
    cursor: pointer;
    width: 100px;
    font-weight: 300;
    &:hover {
      color: #fff;
      font-size: 20px;
      font-weight: 340;
    }
  }
  .btn2 {
    margin-left: 60px;
    width: 100px;
    font-size: 18px;
    cursor: pointer;
    font-weight: 300;
    &:hover {
      color: #fff;
      font-size: 20px;
      font-weight: 340;
    }
  }
}
.layour {
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0;
  background: url('~@/static/images/interview-banner-bg-1.png') no-repeat center
    center;
  z-index: 0;
  vertical-align: bottom;
  position: absolute;
  background-size: cover;
  .inner {
    width: 513px;
    height: 492px;
    background: url('~@/static/images/interview-banner-bg-2.png') no-repeat center
      center;
    margin: auto;
    vertical-align: bottom;
    display: block;
    background-size: cover;
  }
  .box1 {
    padding: 100px 0px 30px;

    img {
      height: 45px;
    }
  }
  .text {
    height: 150px;
    padding: 30px 20px 20px;
    color: #fff;
    font-weight: 300;
    line-height: 30px;
    .text1 {
      font-size: 35px;
    }
    .text2 {
      padding: 10px 0px 0px;
      font-size: 18px;
    }
  }
  .info {
    padding: 20px 0px 0px;
    font-size: 18px;
    font-weight: 300;
    .iconfont {
      color: #29bdb9;
      font-size: 26px;
      position: relative;
      top: 3px;
    }
  }
}

.v1 {
  width: 100%;
  height: auto;
}
.banner-2 {
  background: #eaeff3 url('~@/static/images/interview-banner-2-bg.png') no-repeat
    center top;
  background-size: cover;
  height: 100%;
  padding-top: 20px;
  .layout {
    display: grid;
    height: 100%;
  }
  .inner {
    background: url('~@/static/images/interview-banner-2-text-bg.png') no-repeat
      center top;
    width: 539px;
    height: 503px;
    margin: auto;
    padding: 165px 10px 0px 10px;
    color: #29bdb9;
    font-weight: 300;
    .text1 {
      font-size: 26px;
      color: #fff;
      padding: 10px 0px 20px 15px;
    }
    .text2 {
      color: #fff;
      font-size: 18px;
      padding: 15px 0px 0px;
    }
  }
}
@media screen and (max-width: 600px) {
  .bottom-btns {
    .btn1 {
      margin-left: 40px;
      &.ismobile {
        margin-left: 50px;
      }
    }
    .btn2 {
      margin-left: 60px;
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .carouse-inv-mobile {
    .bottom-btns {
      padding: 85px 0 0 0;

      .btn1 {
        margin-left: 150px;
        font-size: 24px;
        width: 120px;
        &.ismobile {
          margin-left: 160px;
        }
      }
      .btn2 {
        width: 120px;
        margin-left: 90px;
        font-size: 24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/interview/carousel.vue